// extracted by mini-css-extract-plugin
module.exports = {"linktreeH1":"linktree-module--linktree-h1--2w4Go"};